<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Caixa de Mensagens.</span>
                <br />
                <span class="navigation"></span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataIni" name="dataIni" v-model="dataInicial" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Inicial" @keyup.enter="pesquisar" :disabled="search" />
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataFim" name="dataFim" v-model="dataFinal" :showIcon="true" dateFormat="dd/mm/yy"
                  placeholder="Data Final" @keyup.enter="pesquisar" :disabled="search" />
              </span>
            </div>
            <div class="mb-2">
              <Button @click="pesquisar()" label="Pesquisar" type="button" class="p-button-primary mr-2"
                icon="pi pi-search" :disabled="search" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 mb-2">
              <label for="newMessage">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Nova Mensagem" id="newMessage" icon="pi pi-check" @click="novaMensagem"
                  title="Nova Mensagem" />
              </span>
            </div>
            <div class="col-md-2 mb-2" v-if="isAdmin">
              <label for="newMessage">&nbsp;</label>
              <span class="p-fluid">
                <Button label="Receber por E-mail" id="btnEmailAdmin" class="p-button-secondary" icon="pi pi-envelope"
                  @click="exibirDialogEmail" title="Receber Mensagens por E-mail" />
              </span>
            </div>
          </div>
          <TabView>
            <TabPanel header="Recebidas">
              <DataTable :value="msgRecibidas" :paginator="true" :rows="10" class="p-datatable-responsive"
                :autoLayout="true" :rowClass="rowClass" :selection.sync="selectedMensagem" selectionMode="single"
                dataKey="id" @row-select="onRowSelect">
                <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                  <template #body="slotProps">
                    <Button type="button" title="Anexos" icon="pi pi-upload" style="margin-right: 0.5em"
                      @click="carregarAnexos(slotProps.data.id)"></Button>
                    <Button type="button" title="Arquivar Mensagem" icon="pi pi-file-excel"
                      @click="arquivar(slotProps.data.id, 'S')"></Button>
                  </template>
                </Column>
                <Column field="remetente" header="Remetente" headerStyle="width: 25em"></Column>
                <Column field="mensagemResumida" header="Mensagem"></Column>
                <Column field="dataFormatada" header="Data" headerStyle="width: 8em"></Column>
                <Column field="respondida" header="Respondida" headerStyle="width: 10em"></Column>
              </DataTable>
            </TabPanel>
            <TabPanel header="Enviadas">
              <DataTable :value="msgEnviadas" :paginator="true" :rows="10" class="p-datatable-responsive"
                :autoLayout="true" :selection.sync="selectedMensagem" selectionMode="single" dataKey="id"
                @row-select="onRowEnviadasSelect">
                <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                  <template #body="slotProps">
                    <Button type="button" title="Anexos" icon="pi pi-upload" style="margin-right: 0.5em"
                      @click="carregarAnexos(slotProps.data.id)"></Button>
                  </template>
                </Column>
                <Column field="remetente" header="Remetente" headerStyle="width: 25em"></Column>
                <Column field="destinatario" header="Destinatário" headerStyle="width: 25em"></Column>
                <Column field="mensagemResumida" header="Mensagem"></Column>
                <Column field="dataFormatada" header="Data" headerStyle="width: 8em"></Column>
                <Column field="lida" header="Lida" headerStyle="width: 5em"></Column>
              </DataTable>
            </TabPanel>
            <TabPanel header="Arquivadas">
              <DataTable :value="msgArquivadas" :paginator="true" :rows="10" class="p-datatable-responsive"
                :autoLayout="true" :rowClass="rowClass">
                <Column headerStyle="width: 8em" bodyStyle="text-align: center">
                  <template #body="slotProps">
                    <Button type="button" title="Retornar para Recebidas" icon="pi pi-check" style="margin-right: 0.5em"
                      @click="arquivar(slotProps.data.id, 'N')"></Button>
                  </template>
                </Column>
                <Column field="remetente" header="Remetente" headerStyle="width: 25em"></Column>
                <Column field="mensagemResumida" header="Mensagem"></Column>
                <Column field="dataFormatada" header="Data" headerStyle="width: 8em"></Column>
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>

    <Dialog :visible.sync="displayEmailAdmin" class="modal-interno-custom" :contentStyle="{ overflow: 'visible' }"
      :modal="true">
      <h1 class="titulo-header">
        Receber Mensagens por E-mail
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayEmailAdmin = false" />
      </h1>
      <div class="scrolable-dialogg">
        <div class="row">
          <div class="col-md-12 mb-2">
            <div class="p-inputgroup">
              <InputText v-model="emailAdmin" placeholder="Adicionar E-mail" />
              <Button title="Adicionar E-mail" icon="pi pi-plus" @click="adicionarEmail()" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2">
            <span class="p-fluid">
              <div class="flex align-items-center">
                <Chip class="mt-2 mr-2 custom-chip" v-for="(str, index) in listaEmailAdmin" :key="str" :label="str"
                  @remove="removerEmail(index)" removable />
              </div>
            </span>
            <div class="mt-4">
              Os e-mails listados acima receberão cópias das Mensagens destinadas ao Grupo de Administradores.
            </div>

            <div class="botoes-avancar-voltar" style="margin-top: 10px;">
              <Button :disabled="loadingMensagemAnexo" label="Gravar" icon="pi pi-check" @click="gravarEmail"
                title="Gravar" />
              <Button label="Fechar" icon="pi pi-times" @click="displayEmailAdmin = false" title="Fechar"
                class="p-button-danger" />
            </div>

          </div>
        </div>
      </div>
    </Dialog>

    <Dialog :visible.sync="displayNewMessage" class="modal-interno-custom" :contentStyle="{ overflow: 'visible' }"
      :modal="true">
      <h1 class="titulo-header">
        Nova Mensagem
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayNewMessage = false" />
      </h1>
      <div class="scrolable-dialogg">
        <div class="row2" v-if="isAdmin">
          <div class="mb-2">
            <label for="tipoSelecao">Tipo Seleção:</label>
            <span class="p-fluid">
              <Dropdown id="tipoSelecao" name="tipoSelecao" v-model="selectedTipoSelecao" :options="tiposSelecao"
                optionLabel="name" placeholder="Selecione um Tipo" />
            </span>
          </div>
        </div>
        <div class="row2" v-if="isAdmin && selectedTipoSelecao.key != 'T'">
          <div class="col-md-12 mb-2">
            <label for="contr">Contribuinte:</label>
            <span class="p-fluid">
              <AutoComplete id="contr" v-model="selectedContribuinte" :dropdown="true"
                :suggestions="filteredContribuintes" @complete="searchContribuinte($event)" field="nome">

              </AutoComplete>
            </span>
          </div>
        </div>
        <div class="row2">
          <div class="mb-2">
            <label>Tipo Mensagem:</label>
            <span class="p-fluid">
              <Dropdown id="tipoMensagem" v-model="selectedTipoMensagem" :options="tiposMensagem" optionLabel="nome"
                placeholder="Selecione um Tipo de Mensagem" />
            </span>
          </div>
        </div>
        <div class="row2">
          <div class="mb-2">
            <label for="descServico">Mensagem:</label>
            <span class="p-fluid">
              <textarea v-model="mensagem.mensagem" rows="5" />
            </span>
          </div>
        </div>
        <div class="row2">
          <div class="col-md-12 mb-2">
            <label for="descServico">Anexar Arquivo:</label>
            <br />
            <input type="file" @change="onFileChanged" accept="*" />
          </div>

          <div class="botoes-avancar-voltar">
            <Button :disabled="loadingMensagemAnexo" label="Enviar" icon="pi pi-check" @click="salvarMensagem"
              title="Enviar" />
            <Button label="Fechar" icon="pi pi-times" @click="displayNewMessage = false" title="Fechar"
              class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog :visible.sync="displayReadMessage" class="modal-interno-custom" :contentStyle="{ overflow: 'visible' }"
      :modal="true">
      <h1 class="titulo-header">
        Link Envio RPS
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayReadMessage = false" />/>
      </h1>
      <div class="scrolable-dialogg">
        <div class="row">
          <div class="col-md-12 mb-2">
            <span class="p-fluid">
              <textarea v-model="mensagem.mensagem" rows="5" disabled="true" />
            </span>
          </div>
        </div>
        <div class="row2">
          <div class="col-md-12 mb-2">
            <label for="descServico">Resposta:</label>
            <span class="p-fluid">
              <textarea v-model="resposta" rows="5" />
            </span>
          </div>
        </div>
        <div class="row2">
          <div class="col-md-12 mb-2">
            <label for="descServico">Anexar Arquivo:</label>
            <br />
            <input type="file" @change="this.selectedTipoSelecao.key === 'T' ? handleFileUploads : onFileChanged"
              accept="*" />
          </div>
          <div class="botoes-avancar-voltar" style="margin-top: 10px;">
            <Button label="Responder" icon="pi pi-check" @click="enviarResposta" title="Enviar"
              v-if="habilitarRespostaMensagem(mensagem)" />
            <Button label="Fechar" icon="pi pi-times" @click="displayReadMessage = false" title="Fechar"
              class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog :visible.sync="displayResponseMessage" class="modal-interno-custom" :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <div class="scrolable-dialogg">
        <div class="row2" v-if="(selectedMensagem && selectedMensagem.idOrigem && selectedMensagem.idOrigem.id)">
          <div class="col-md-12 mb-2">
            <label for="descServico">Pergunta:</label>
            <span class="p-fluid">
              <textarea v-model="selectedMensagem.idOrigem.mensagem" rows="5" disabled="true" />
            </span>
          </div>
        </div>
        <div class="row2" v-if="(selectedMensagem)">
          <div class="col-md-12 mb-2">
            <label for="descServico">Mensagem Enviada:</label>
            <span class="p-fluid">
              <textarea v-model="selectedMensagem.mensagem" rows="5" disabled="true" />
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="displayResponseMessage = false" title="Fechar"
              class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog :visible.sync="displayAnexos" class="modal-interno-custom" :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Anexos
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayAnexos = false" />
      </h1>
      <div >
        <div class="row">
          <DataTable :value="anexos" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
            <Column headerStyle="width: 8em" bodyStyle="text-align: center">
              <template #body="slotProps">
                <Button type="button" icon="pi pi-download" style="margin-right: 0.5em"
                  @click="downloadAnexo(slotProps.data)"></Button>
              </template>
            </Column>
            <Column field="nomeArquivo" header="Nome" ></Column>
          </DataTable>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="displayAnexos = false" title="Fechar"
              class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import UsuarioAcessoService from "../services/nfse/usuario.acesso.service";
import TrbMensagemService from "../services/tributario/trb.mensagem.service";
import Mensagem from "../models/tributario/Mensagem";
import Util from "../Utils/util";

export default {
  name: "caixaMensagem",
  data() {
    return {
      isAdmin: false,
      search: false,
      displayNewMessage: false,
      displayReadMessage: false,
      displayResponseMessage: false,
      displayAnexos: false,
      displayEmailAdmin: false,
      currentUser: null,
      dataInicial: null,
      dataFinal: null,
      msgRecibidas: [],
      msgEnviadas: [],
      msgArquivadas: [],
      anexos: [],
      mensagem: new Mensagem(),
      selectedTipoMensagem: null,
      tiposMensagem: [],
      selectedMensagem: null,
      selectedFile: null,
      resposta: null,
      selectedTipoSelecao: null,
      tiposSelecao: [
        { name: "Todos Contribuintes", key: "T" },
        { name: "Selecionar Contribuinte", key: "S" }
      ],
      selectedContribuinte: null,
      filteredContribuintes: [],
      files: "",
      loadingMensagemAnexo: false,
      listaEmailAdmin: [],
      emailAdmin: null
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.isAdmin = this.currentUser.usuario.idBolAdmin;
    this.selectedTipoSelecao = this.tiposSelecao[0];
    this.clear();
  },
  methods: {
    onFileChanged(event) {
      const file = event.target.files[0];
      this.selectedFile = file;
    },
    onRowSelect(event) {
      this.processando(true);
      TrbMensagemService.saveLida(event.data.id)
        .then(
          (data) => {
            console.log(data.data);
            this.novaResposta(event.data);
          },
          (error) => {
            console.log(error.data);
            this.$root.$emit(
              "alert:error",
              "Erro ao marcar mensagem como Lida!"
            );
          }
        )
        .then(() => {
          this.processando(false);
        });
      event.data.idBolLida = "S";
    },
    onRowEnviadasSelect(event) {
      this.processando(true);
      this.selectedMensagem = event.data;
      this.displayResponseMessage = true;
      this.processando(false);
    },
    arquivar(id, opcao) {
      this.processando(true);
      TrbMensagemService.saveArquivada(id, opcao)
        .then(
          (data) => {
            console.log(data.data);
          },
          (error) => {
            console.log(error.data);
            this.$root.$emit(
              "alert:error",
              "Erro ao marcar mensagem como Arquivada!"
            );
          }
        )
        .then(() => {
          this.pesquisar();
          this.processando(false);
        });
    },
    rowClass(data) {
      return data.idBolLida === "N" ? "row-bold" : null;
    },
    downloadAnexo(arquivo) {
      this.processando(true);

      TrbMensagemService.getAnexo(
        arquivo
      )
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao fazer download do anexo!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    carregarAnexos(idMsg) {
      setTimeout(async () => {
        this.anexos = await TrbMensagemService.findAllAnexos(
          idMsg
        );
        this.displayAnexos = true;
      }, 250);
    },

    handleFileUploads() {
      this.files = this.$refs.files.files;
    },

    salvarMensagem() {
      if (this.selectedFile) {
        var fileSize = this.selectedFile.size / 1024 / 1024; // in MB
        if (fileSize > 20) {
          this.$root.$emit(
            "alert:warn",
            "Este arquivo ultrapassa o limite de 20 MB!"
          );
          return;
        }
        this.processando(true);
        this.getBase64(this.selectedFile).then(response => {

          let base64 = response.replace("data:", "").replace(/^.+,/, "");
          this.mensagem.file = base64;

          this.mensagem.nomeArquivo = this.selectedFile.name;
          this.mensagem.tipoArquivo = this.selectedFile.type;

          this.enviarMensagem();
        });
      } else {
        this.enviarMensagem();
      }
    },

    enviarMensagem() {
      if (this.isAdmin && this.selectedTipoSelecao.key === 'S' && (this.selectedContribuinte == null || !this.selectedContribuinte.idUsuario)) {
        this.$root.$emit("alert:warn", "Preencha o Contribuinte!");
      } else if (this.mensagem.mensagem === "") {
        this.$root.$emit("alert:warn", "Preencha a Mensagem!");
      } else if (this.selectedTipoMensagem == null) {
        this.$root.$emit("alert:warn", "Preencha o Tipo de Mensagem!");
      } else if (//apenas arquivos de até 30 megas
        this.selectedFile &&
        this.selectedFile.size / 1024 / 1024 > 30
      ) {
        this.$root.$emit(
          "alert:warn",
          "Tamanho do arquivo maior do que o permitido 30MB!"
        );
      } else if (
        this.selectedFile &&
        this.selectedFile.name &&
        this.selectedFile.name.length > 80
      ) {
        this.$root.$emit(
          "alert:warn",
          "Nome do arquivo inválido, informe um nome menor!"
        );
      } else {
        this.processando(true);
        this.loadingMensagemAnexo = true;
        let idUserRemetente = null;
        if (this.isAdmin) {
          idUserRemetente = this.currentUser.usuario.idUsuario;
        } else {
          idUserRemetente = this.currentUser.contribuinte.idUsuario;
        }
        this.mensagem.idUserRemetente = idUserRemetente;
        this.mensagem.idTipoMensagem = this.selectedTipoMensagem.id;
        if (this.isAdmin) {
          this.mensagem.envioAdmin = 'S';
          if (this.selectedTipoSelecao.key === 'S') {
            this.mensagem.idUserDestinatario = this.selectedContribuinte.idUsuarioSelecionado;
          }
        }
        if (this.isAdmin && this.selectedTipoSelecao.key === 'T') {
          this.$toast.add({
            severity: "warn",
            summary: "Aguarde a conclusão do envio de mensagens!",
            life: 4000
          });
          console.log("mensagem com anexo");
          TrbMensagemService.saveMensagemAnexo(
            this.currentUser.usuario.idCliente,
            this.mensagem,
          ).then(
            (data) => {
              console.log(data);
              this.pesquisar();
              this.$root.$emit(
                "alert:success",
                "Mensagem Enviada com sucesso!"
              );
              this.displayNewMessage = false;
              this.processando(false);
              this.loadingMensagemAnexo = false;
            }
          );
        } else {
          TrbMensagemService.save(
            this.mensagem,
            this.currentUser.usuario.idCliente
          )
            .then(
              (data) => {
                console.log(data);
                console.log(data.data);
                let idMsg = (data.data && data.data.id ? data.data.id : null);
                if (idMsg && this.selectedFile) {
                  TrbMensagemService.saveAnexo(idMsg, this.selectedFile);
                }
                this.pesquisar();
                this.$root.$emit(
                  "alert:success",
                  "Mensagem Enviada com sucesso!"
                );
                this.processando(false);
                this.displayNewMessage = false;
                this.loadingMensagemAnexo = false;
              },
              (error) => {
                console.log(error.data);
                this.$root.$emit(
                  "alert:error",
                  "Houve um problema ao enviar a Mensagem!"
                );
              }
            )
            .then(() => {
              this.processando(false);
            });
        }
      }
    },
    enviarResposta() {
      if (!this.selectedMensagem || !this.selectedMensagem.id) {
        this.$root.$emit("alert:warn", "Erro ao carregar mensagem para resposta!");
      } else if (this.resposta === "") {
        this.$root.$emit("alert:warn", "Preencha a Mensagem!");
      } else if (//apenas arquivos de até 30 megas
        this.selectedFile &&
        this.selectedFile.size / 1024 / 1024 > 30
      ) {
        this.$root.$emit(
          "alert:warn",
          "Tamanho do arquivo maior do que o permitido 30MB!"
        );
      } else if (
        this.selectedFile &&
        this.selectedFile.name &&
        this.selectedFile.name.length > 80
      ) {
        this.$root.$emit(
          "alert:warn",
          "Nome do arquivo inválido, informe um nome menor!"
        );
      } else {
        this.processando(true);
        let idUserRemetente = null;
        if (this.isAdmin) {
          idUserRemetente = this.currentUser.usuario.idUsuario;
        } else {
          idUserRemetente = this.currentUser.contribuinte.idUsuario;
        }

        TrbMensagemService.saveResposta(
          idUserRemetente,
          this.selectedMensagem.id,
          this.resposta
        )
          .then(
            (data) => {
              console.log(data);
              console.log(data.data);
              let idMsg = data.data.id;
              if (idMsg && this.selectedFile) {
                TrbMensagemService.saveAnexo(idMsg, this.selectedFile);
              }
              this.pesquisar();
              this.$root.$emit(
                "alert:success",
                "Resposta Enviada com sucesso!"
              );
              this.displayNewMessage = false;
            },
            (error) => {
              console.log(error.data);
              this.$root.$emit(
                "alert:error",
                "Houve um problema ao enviar a Resposta!"
              );
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    novaMensagem() {
      this.processando(true);
      this.mensagem = new Mensagem();
      this.selectedContribuinte = null;
      this.selectedTipoSelecao = this.tiposSelecao[0];
      this.selectedTipoMensagem = null;
      this.selectedFile = null;
      setTimeout(async () => {
        this.tiposMensagem = await TrbMensagemService.findAllTiposMensagem(
          this.currentUser.usuario.idCliente
        );
      }, 250);
      this.displayNewMessage = true;
      this.processando(false);
    },

    exibirDialogEmail() {
      this.processando(true);

      TrbMensagemService.findAllEmailAdmin(this.currentUser.usuario.idCliente).then(
        (data) => {
          if (data) {
            this.listaEmailAdmin = data;
          }
          this.displayEmailAdmin = true;
        },
        (error) => {
          if (error.response && error.response.data) {
            this.$root.$emit("alert:warn", error.response.data);
          } else {
            this.$root.$emit("alert:warn", "Não foi possível carregar a lista de e-mails!");
          }
        }
      ).then(() => {
        this.processando(false);
      });
    },

    adicionarEmail() {
      if (Util.validarEmail(this.emailAdmin) && !this.listaEmailAdmin.includes(this.emailAdmin)) {
        this.listaEmailAdmin.push(this.emailAdmin);
        this.emailAdmin = null;
      } else {
        this.$root.$emit(
          "alert:warn",
          "O e-mail informado não é válido!"
        );
      }
    },

    removerEmail(index) {
      this.listaEmailAdmin.splice(index, 1);
    },

    gravarEmail() {
      this.processando(true);

      TrbMensagemService.saveAllEmailAdmin(
        this.currentUser.usuario.idCliente, this.listaEmailAdmin.join(';')
      ).then(
        (data) => {
          console.log(data);
          this.$root.$emit("alert:success", "Lista de e-mails salva com sucesso!");
        },
        (error) => {
          if (error.response && error.response.data) {
            this.$root.$emit("alert:warn", error.response.data);
          } else {
            this.$root.$emit("alert:warn", "Não foi possível salvar a lista de e-mails!");
          }
        }
      ).then(() => {
        this.listaEmailAdmin = [];
        this.processando(false);
        this.displayEmailAdmin = false;
      });
    },

    searchContribuinte(event) {
      setTimeout(async () => {
        this.filteredContribuintes =
          await UsuarioAcessoService.findAllContrs(
            this.currentUser.usuario.idCliente,
            this.currentUser.usuario.idUsuario,
            event.query

          )

      }, 500);
    },
    novaResposta(mensagem) {
      this.mensagem = mensagem;
      this.resposta = null;
      this.selectedFile = null;
      this.displayReadMessage = true;
    },
    clear() {
      this.dataInicial = new Date();
      this.dataFinal = new Date();
      this.dataInicial.setDate(this.dataInicial.getDate() - 30);
      this.mensagem = new Mensagem();
      this.pesquisar();
    },
    processando(show) {
      if (show) {
        this.$root.$emit("loading:show");
      } else {
        this.$root.$emit("loading:hide");
      }
    },
    habilitarRespostaMensagem(mensagem) {
      console.log('checar');
      console.log(mensagem);
      if (mensagem && mensagem.tipoMensagem && mensagem.tipoMensagem.idBolUsoSistema === 'S') {
        return false;
      }
      return true;
    },
    pesquisar() {
      this.search = true;
      setTimeout(async () => {
        this.msgRecibidas =
          await TrbMensagemService.findAllMensagensReceebidasByUsuario(
            this.currentUser.usuario.idCliente,
            this.currentUser.usuario.idUsuario,
            this.currentUser.contribuinte.idUsuarioContr,
            this.dataInicial,
            this.dataFinal
          );
        this.msgEnviadas =
          await TrbMensagemService.findAllMensagensEnviadasByUsuario(
            this.currentUser.usuario.idCliente,
            this.currentUser.usuario.idUsuario,
            this.currentUser.contribuinte.idUsuarioContr,
            this.dataInicial,
            this.dataFinal
          );
        this.msgArquivadas =
          await TrbMensagemService.findAllMensagensArquivadasByUsuario(
            this.currentUser.usuario.idCliente,
            this.currentUser.usuario.idUsuario,
            this.currentUser.contribuinte.idUsuarioContr,
            this.dataInicial,
            this.dataFinal
          );
        this.search = false;
      }, 250);
    },
  },
};
</script>

<style src="../assets/css/caixaMensagem.css"></style>
